var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"sidebar"},[_c('img',{staticClass:"w-50 d-block mx-auto my-16",attrs:{"src":"/image/logo-white.png","alt":"","width":"50%"}})]),_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }